export const setSelectValue = (value: string, type: string) => {
  (window as any).emitter.on('select:loaded', () => {
    (window as any).emitter.emit('select:setChoice', { value, type });
  });
};
